import { useEffect, useState } from "react";

import { useAuth } from "@/auth";
import { fetchMeProBuyer } from "@/features/pro-buyer-application/data/pro-buyer-application-client";

export type ProBuyerStatus =
  | { state: "signed_out" }
  | { state: "loading" }
  | { state: "ready"; proBuyer: boolean };

/**
 * WHO-5688. Whether the logged-in viewer already is a Pro Buyer. Read fresh
 * on every visit (never cached), so a flag CS flipped shows on the next load.
 * A gateway that cannot answer counts as "not a Pro Buyer": the form shows and
 * the mutation itself answers ALREADY_PRO_BUYER if that was wrong.
 */
export const useProBuyerStatus = (): ProBuyerStatus => {
  const { token, isLoggedIn, isReady } = useAuth();
  const [proBuyer, setProBuyer] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isLoggedIn || !token) {
      setProBuyer(null);

      return;
    }

    let cancelled = false;

    void fetchMeProBuyer(token).then(value => {
      if (!cancelled) {
        setProBuyer(value ?? false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, token]);

  if (!isReady) {
    return { state: "loading" };
  }

  if (!isLoggedIn) {
    return { state: "signed_out" };
  }

  if (proBuyer === null) {
    return { state: "loading" };
  }

  return { state: "ready", proBuyer };
};
